module.exports = __webpack_public_path__ + "static/media/PassPhotoExample.9061f23d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/PassPhotoExample.jpg
// module id = 1695
// module chunks = 0